import { render, staticRenderFns } from "./problemFollow.vue?vue&type=template&id=8e88f24e&scoped=true&"
import script from "./problemFollow.vue?vue&type=script&lang=js&"
export * from "./problemFollow.vue?vue&type=script&lang=js&"
import style0 from "./problemFollow.vue?vue&type=style&index=0&id=8e88f24e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e88f24e",
  null
  
)

export default component.exports